<template>
  <div class="ai-platform-page hero-style-home">
    <div class="ai-hero-banner">
      <img
        src="@/assets/jiejue/custom/internet-egress-hero-banner.svg"
        alt=""
        style="width: 100%"
        @load="loaded = true"
        :class="{ show: loaded }"
        class="top_img"
      />
      <div class="ai-hero-title">互联网出口安全解决方案</div>
    </div>

    <nav class="product-tabs-bar">
      <a
        class="product-tab"
        :class="{ active: activeTab === 'background' }"
        href="#background"
        @click.prevent="scrollTo('background')"
      >需求背景</a>
      <a
        class="product-tab"
        :class="{ active: activeTab === 'challenges' }"
        href="#challenges"
        @click.prevent="scrollTo('challenges')"
      >业务挑战</a>
      <a
        class="product-tab"
        :class="{ active: activeTab === 'scenarios' }"
        href="#scenarios"
        @click.prevent="scrollTo('scenarios')"
      >场景应用</a>
      <a
        v-if="SHOW_SOLUTION_DEPLOY_DIAGRAM"
        class="product-tab"
        :class="{ active: activeTab === 'architecture' }"
        href="#architecture"
        @click.prevent="scrollTo('architecture')"
      >部署示意图</a>
      <a
        class="product-tab"
        :class="{ active: activeTab === 'advantages' }"
        href="#advantages"
        @click.prevent="scrollTo('advantages')"
      >方案优势</a>
      <a
        class="product-tab"
        :class="{ active: activeTab === 'cases' }"
        href="#cases"
        @click.prevent="scrollTo('cases')"
      >典型案例</a>
    </nav>

    <div class="product-body">
      <section
        id="background"
        class="product-section section-row ai-platform-block"
        :class="{ 'animate-in': backgroundVisible }"
      >
        <div class="section-title">需求背景</div>
        <div class="section-content">
          <div class="background-card">
            <p class="case-text case-text-full">
              长期以来，企业普遍采用以网络为中心、依托物理拓扑配置策略的传统安全架构，各类安全设备多以串接、旁路镜像方式部署，这种「糖葫芦」式架构虽部署简易、拓展直观，但灵活性不足、安全能力单一固化，难以适配当下以业务应用为核心的主动化、个性化防护需求；而基于 SSLO 安全流量编排器构建的流量编排方案，可重构传统安全部署模式，搭建安全资源池，实现安全设备与业务流量的统一智能调度，全面强化企业整体安全防护水平。
            </p>
          </div>
        </div>
      </section>

      <section
        id="challenges"
        class="product-section section-row ai-platform-block"
        :class="{ 'animate-in': challengesVisible }"
        style="background-color: #fff"
      >
        <div class="section-title">业务挑战</div>
        <div class="section-content">
          <div class="grid-2">
            <div class="card">
              <img class="card-icon" src="@/assets/jiejue/1.svg" alt="">
              <div class="card-text">
                <div class="card-title">性能瓶颈突出</div>
                <div class="card-desc">
                  传统架构下全部业务流量串行经过多类安全设备，受限于链路短板效应，整体转发效率低、网络性能损耗严重。
                </div>
              </div>
            </div>
            <div class="card">
              <img class="card-icon" src="@/assets/jiejue/2.svg" alt="">
              <div class="card-text">
                <div class="card-title">加密流量防护缺失</div>
                <div class="card-desc">
                  无法对加密流量开展深度解析与威胁检测，存在隐蔽攻击入侵风险，防护覆盖面不足。
                </div>
              </div>
            </div>
            <div class="card">
              <img class="card-icon" src="@/assets/jiejue/3.svg" alt="">
              <div class="card-text">
                <div class="card-title">扩容改造难度大</div>
                <div class="card-desc">
                  安全设备仅支持替换式升级，扩容需开展网络割接，极易影响核心业务稳定，且配置调试工作量繁重。
                </div>
              </div>
            </div>
            <div class="card">
              <img class="card-icon" src="@/assets/jiejue/4.svg" alt="">
              <div class="card-text">
                <div class="card-title">运维排障压力大</div>
                <div class="card-desc">
                  多设备串接部署导致故障节点增多，链路结构复杂，日常故障定位与问题排查难度大幅提升。
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        id="scenarios"
        class="product-section section-row ai-platform-block"
        :class="{ 'animate-in': scenariosVisible }"
      >
        <div class="section-title">场景应用</div>
        <div class="section-content">
          <div class="scenarios">
            <div class="scenario-text">
              <div class="scenario-item">
                <div class="item-title">多业务混合部署场景</div>
                <div class="item-desc">
                  SSLO 精准识别并分类调度不同业务流量，为核心生产、普通办公、研发等业务匹配差异化防护链路，避免全流量串行经过所有设备造成的性能损耗，实现性能与防护的个性化适配。
                </div>
              </div>
              <div class="scenario-item">
                <div class="item-title">加密流量检测场景</div>
                <div class="item-desc">
                  SSLO 实现加密流量集中解密与统一威胁检测，无需改动现有网络架构即可精准识别加密流量中的恶意代码与异常行为，在保障数据传输安全的同时满足金融行业合规要求。
                </div>
              </div>
              <div class="scenario-item">
                <div class="item-title">安全设备灵活扩容场景</div>
                <div class="item-desc">
                  SSLO 构建安全资源池，支持安全设备横向扩容与按需接入，无需网络割接即可实现新设备快速上线与算力分配，有效适配业务增长并降低升级成本与中断风险。
                </div>
              </div>
              <div class="scenario-item">
                <div class="item-title">运维复杂度高、故障排查困难场景</div>
                <div class="item-desc">
                  SSLO 实现全网安全设备与流量的统一管控，实时监控各链路运行状态并精准定位故障节点，无需现场操作即可完成排查修复；同时集中编排分支流量、统一防护策略，显著降低跨区域运维难度。
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        v-if="SHOW_SOLUTION_DEPLOY_DIAGRAM"
        id="architecture"
        class="product-section section-row ai-platform-block"
        :class="{ 'animate-in': architectureVisible }"
        style="background-color: #fff"
      >
        <div class="section-title">部署示意图</div>
        <div class="section-content">
          <img src="@/assets/solutions/deploy/internet-egress.svg" alt="部署示意图" class="architecture-image" />
        </div>
      </section>

      <section
        id="advantages"
        class="product-section section-row advantages ai-platform-block"
        :class="{ 'animate-in': advantagesVisible }"
      >
        <div class="section-title">方案优势</div>
        <div class="section-content">
          <div class="grid-4">
            <div class="adv-card">
              <img src="@/assets/jiejue/1.svg" alt="" class="adv-badge">
              <div class="adv-title">提升效率</div>
              <div class="adv-desc">解决串接安全设备过多导致的效率与性能低下问题。</div>
            </div>
            <div class="adv-card">
              <img src="@/assets/jiejue/2.svg" alt="" class="adv-badge">
              <div class="adv-title">解密流量检测分析</div>
              <div class="adv-desc">实现对加密流量的深层次威胁检测与分析。</div>
            </div>
            <div class="adv-card">
              <img src="@/assets/jiejue/3.svg" alt="" class="adv-badge">
              <div class="adv-title">提升业务持续性</div>
              <div class="adv-desc">缓解故障点过多、排障复杂困难等问题。</div>
            </div>
            <div class="adv-card">
              <img src="@/assets/jiejue/4.svg" alt="" class="adv-badge">
              <div class="adv-title">安全能力平滑扩容</div>
              <div class="adv-desc">扩容只需增加安全资源池内相应安全设备，对网络无影响，配置等工作量小。</div>
            </div>
          </div>
        </div>
      </section>

      <section
        id="cases"
        class="product-section section-row ai-platform-block"
        :class="{ 'animate-in': casesVisible }"
      >
        <div class="section-title">典型案例</div>
        <div class="section-content section-content-cases">
          <div class="case-content case-content-blink">
            <div class="case-section">
              <h3 class="case-subtitle">需求背景</h3>
              <p class="case-text">
                某企业 IDC 数据中心互联网出口业务持续扩容，原有安全设备部署分散、流量调度固化，传统串行防护模式无法按业务差异化处置流量，存在性能与防护短板。为优化出口网络架构，需部署流量编排设备，整合硬件安全资源，基于业务类型实现流量分级编排与精准防护，提升边界安全能力与网络运行效率。
              </p>
            </div>
            <div class="case-section">
              <h3 class="case-subtitle">用户痛点</h3>
              <ul class="case-list">
                <li>存量架构改造难度大：现有 IDC 网络架构成熟、业务链路复杂，多类安全设备兼容对接困难，改造易干扰现有业务稳定运行。</li>
                <li>业务流量识别精细化不足：互联网出口流量类型多、流向复杂，难以精准区分业务流量，不利于精细化编排策略落地。</li>
                <li>安全资源协同调度复杂：各类硬件安全设备规格、策略不统一，集中纳管与联动调度难度高，防护与性能难以平衡。</li>
                <li>行业合规与连续性要求严苛：行业业务连续性、合规标准高，部署调试及运维应急保障压力大，实施管控要求严格。</li>
              </ul>
            </div>
            <div class="case-section">
              <h3 class="case-subtitle">解决方案</h3>
              <ul class="case-list">
                <li>采用旁挂式部署，兼容多厂商存量安全设备，通过平滑切换、灰度部署机制，实现架构改造「零中断」，降低设备对接与改造风险。</li>
                <li>依靠 VSW 的服务链编排能力，根据 IP 五元组匹配各类业务及协议流量，支持自定义规则与多维度解析，建立流量标签体系，落地精细化编排策略。</li>
                <li>采用 SSLO 集中纳管异构安全设备，通过自定义服务链实现资源按需调用，平衡防护效果与网络性能，保障防护连续性。</li>
                <li>遵循行业合规标准，支持国密算法，采用双机热备与故障自动切换机制保障业务连续，通过离线配置、可视化运维及日志留存，满足合规与运维需求。</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>

    
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { SHOW_SOLUTION_DEPLOY_DIAGRAM } from '@/data/solutionUi.js'
import ssloHero from '@/assets/jiejue/custom/internet-egress-hero-banner.svg'

const loaded = ref(false)

defineOptions({
  banner: ssloHero,
})

const activeTab = ref('background')
const isScrollingProgrammatically = ref(false)
const isUserScrolling = ref(false)
let userScrollTimeout = null
const animationObserver = ref(null)
const navObserver = ref(null)
let navTimeout = null
let handleUserScroll = null

const backgroundVisible = ref(false)
const challengesVisible = ref(false)
const scenariosVisible = ref(false)
const architectureVisible = ref(false)
const advantagesVisible = ref(false)
const casesVisible = ref(false)

const scrollTo = (id) => {
  const el = document.getElementById(id)
  if (!el) return
  activeTab.value = id
  history.replaceState(null, '', `#${id}`)
  isScrollingProgrammatically.value = true
  if (el.scrollIntoView) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' })
  } else {
    const stickyOffset = 120
    const y = el.getBoundingClientRect().top + window.scrollY - stickyOffset
    window.scrollTo({ top: y, behavior: 'smooth' })
  }
  setTimeout(() => {
    isScrollingProgrammatically.value = false
  }, 1000)
}

onMounted(() => {
  activeTab.value = 'background'

  handleUserScroll = () => {
    if (isScrollingProgrammatically.value) return
    isUserScrolling.value = true
    if (userScrollTimeout) clearTimeout(userScrollTimeout)
    userScrollTimeout = setTimeout(() => {
      isUserScrolling.value = false
    }, 150)
  }
  window.addEventListener('scroll', handleUserScroll, { passive: true })

  animationObserver.value = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const id = entry.target.id
          if (id === 'background') backgroundVisible.value = true
          else if (id === 'challenges') challengesVisible.value = true
          else if (id === 'scenarios') scenariosVisible.value = true
          else if (id === 'architecture') architectureVisible.value = true
          else if (id === 'advantages') advantagesVisible.value = true
          else if (id === 'cases') casesVisible.value = true
        }
      })
    },
    { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
  )

  navObserver.value = new IntersectionObserver(
    (entries) => {
      if (isScrollingProgrammatically.value) return
      if (!isUserScrolling.value) return
      const visibleEntries = entries.filter((entry) => entry.isIntersecting)
      if (visibleEntries.length > 0) {
        if (navTimeout) clearTimeout(navTimeout)
        navTimeout = setTimeout(() => {
          if (isScrollingProgrammatically.value) return
          let maxEntry = visibleEntries[0]
          for (const entry of visibleEntries) {
            if (entry.intersectionRatio > maxEntry.intersectionRatio) {
              maxEntry = entry
            }
          }
          const id = maxEntry.target.id
          if (id && activeTab.value !== id) {
            activeTab.value = id
            history.replaceState(null, '', `#${id}`)
          }
        }, 50)
      }
    },
    {
      root: null,
      threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
      rootMargin: '-80px 0px -50% 0px',
    }
  )

  const ids = ['background', 'challenges', 'scenarios', 'architecture', 'advantages', 'cases']
  ids.forEach((id) => {
    const el = document.getElementById(id)
    if (el) {
      animationObserver.value.observe(el)
      navObserver.value.observe(el)
    }
  })
})

onBeforeUnmount(() => {
  if (animationObserver.value) animationObserver.value.disconnect()
  if (navObserver.value) navObserver.value.disconnect()
  if (navTimeout) clearTimeout(navTimeout)
  if (userScrollTimeout) clearTimeout(userScrollTimeout)
  if (handleUserScroll) {
    window.removeEventListener('scroll', handleUserScroll)
  }
})
</script>

<style scoped>
@import '../../assets/css/solution-page.css';

.ai-hero-banner {
  position: relative;
  overflow: hidden;
  container-type: inline-size;
}

.ai-hero-title {
  position: absolute;
  top: 50%;
  left: max(24px, 6.25cqi);
  transform: translateY(-50%);
  font-size: max(28px, 2.9167cqi);
  font-weight: 700;
  line-height: 1.2;
  color: #ffffff;
  text-shadow: 0 3px 16px rgba(2, 6, 23, 0.45);
  z-index: 2;
  pointer-events: none;
  max-width: min(92%, 720px);
}

.ai-platform-page {
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  color: var(--color-text);
}

.ai-platform-block {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.6s ease, transform 0.6s ease;
}

.ai-platform-block.animate-in {
  opacity: 1;
  transform: translateY(0);
}

.background-card {
  width: 100%;
  box-sizing: border-box;
  background: #fff;
  border-radius: 8px;
  padding: 36px 40px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #e8e8e8;
}

.section-content-cases {
  text-align: left;
}

.section-content-cases .case-content,
.section-content-cases .case-section,
.section-content-cases .case-text,
.section-content-cases .case-list {
  text-align: left;
}

.case-content-blink {
  padding: 24px;
  border-radius: 8px;
  animation: case-blink 2.5s ease-in-out infinite;
}

@keyframes case-blink {
  0%,
  100% {
    opacity: 1;
    box-shadow: 0 0 0 rgba(6, 85, 159, 0);
  }
  50% {
    opacity: 0.88;
    box-shadow: 0 0 28px rgba(6, 85, 159, 0.25);
  }
}

.case-section + .case-section {
  margin-top: 32px;
}

.case-subtitle {
  font-size: 20px;
  font-weight: 600;
  color: #06559f;
  margin-bottom: 12px;
}

.case-text {
  font-size: 14px;
  line-height: 1.8;
  color: #333;
}

.case-text-full {
  font-size: 16px;
  line-height: 1.9;
  text-align: left;
}

.case-list {
  font-size: 14px;
  line-height: 1.8;
  color: #333;
  padding-left: 0;
  list-style: none;
}

.case-list li {
  margin-bottom: 10px;
  padding-left: 0;
}

.scenarios {
  display: flex;
  align-items: stretch;
  position: relative;
  margin: 0 auto;
}

.scenario-text {
  background: #fff;
  border-radius: 4px;
  padding: 50px 0 0 40px;
  box-sizing: border-box;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: hidden;
  text-align: start;
}

.scenario-item {
  margin-bottom: 18px;
}

.scenario-item .item-title {
  font-size: 16px;
  line-height: 16px;
  color: #333;
  margin-bottom: 8px;
  font-family: PingFang SC;
}

.scenario-item .item-desc {
  font-size: 14px;
  line-height: 1.8;
  color: #666;
}

.grid-2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.grid-4 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.card {
  display: flex;
  align-items: flex-start;
  gap: 17px;
  background: #f5f7fa;
  border-radius: 6px;
  padding: 30px;
  min-height: 140px;
  box-sizing: border-box;
}

.card-icon {
  flex-shrink: 0;
}

.card-text {
  display: flex;
  flex-direction: column;
  text-align: start;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #000;
  line-height: 40px;
  margin-bottom: 8px;
}

.card-desc {
  font-size: 14px;
  line-height: 1.7;
  color: #666;
}

.scenario-text-stack {
  display: flex;
  flex-direction: column;
  gap: 28px;
  max-width: 100%;
}

.scenario-item .item-title {
  font-size: 18px;
  font-weight: 600;
  color: var(--color-text);
  margin-bottom: 10px;
}

.scenario-item .item-desc {
  font-size: 16px;
  line-height: 1.8;
  color: var(--color-text-secondary);
}

#advantages {
  background: linear-gradient(180deg, #f5f7fa 0%, #e0ecff 100%);
  max-width: unset;
}

.advantages .grid-4 {
  align-items: stretch;
  gap: 20px;
  max-width: none;
  margin: 0;
}

.adv-card {
  min-height: 200px;
  position: relative;
  background: #fff;
  border-radius: 4px;
  padding: 29px;
  padding-top: 70px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  text-align: start;
}

.adv-badge {
  display: block !important;
  position: absolute;
  top: 33px;
  left: 29px;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  object-fit: contain;
}

.adv-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}

.adv-desc {
  font-size: 14px;
  line-height: 1.6;
  color: #333;
}

@media (max-width: 1200px) {
  .grid-4 {
    grid-template-columns: repeat(2, 1fr);
  }

  .mobile-hidden-img {
    display: none;
  }
}

@media (max-width: 768px) {
  .grid-2,
  .grid-4 {
    grid-template-columns: 1fr;
  }

  .scenario-text {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    width: 100%;
    padding: 40px 30px;
    box-sizing: border-box;
  }

  .scenarios {
    flex-direction: column;
  }
}
</style>
